// Module
var code = `<input class="form-control datetimepicker tft-datepicker" ng-class="{ 'disabled': !tftDatepickerCtrl.canEdit }" type="text" data-toggle="tooltip" readonly="readonly" ng-disabled="!tftDatepickerCtrl.canEdit" title="{{ tftDatepickerCtrl.tooltipLabelKey | translate }}" placeholder="{{ tftDatepickerCtrl.placeholderKey | translate }}">`;
// Exports
export default code;